import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { BounceLoader } from 'react-spinners';
import { URL_TYPE, URL_TOKEN } from '../constants/zoomParameters';
//Axios
import clienteAxios from '../config/axiosNoToken';
import { MSG_ERROR_SERVER } from '../constants/messages';
import Swal from 'sweetalert2';
import { ErrorMessage, WaitingMessage } from './extras/toastMessages';
//Función principal
const Start = () => {
    //Tomo los params
    const { type } = useParams();
    //Me fijo si es el correcto
    if(type !== URL_TYPE){
        //Redirecciono
        window.location.href=process.env.REACT_APP_URL_JUSTUCUMAN;
    }
    //Tomo los query params
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    //Tomo los parámetros q me interesan
    const pwd = query.get(URL_TOKEN);
    //Si no existe ninguno de esos parámetros, debo redireccionar
    if(typeof pwd === 'undefined' || pwd === null || pwd === ''){
        //Redirecciono
        window.location.href=process.env.REACT_APP_URL_JUSTUCUMAN
    }
    //Inicializo el state local
    const [ msg, setMsg ] = useState('Cargando, por favor aguarde...');
    const [ loading, setLoading ] = useState(true);
    //Manejo la búsqueda de datos
    const loadData = async () => {
        //Hago la consulta
        try{
            //Hago la consulta
            const response = await clienteAxios.get(`/audiencia/session/${pwd}`);
            //Obtengo los datos
            const res = response.data;
            //Me fijo si tiene la URL
            if(res.sessionUrl){
                //Muestro mensaje de espera
                WaitingMessage('Redireccionando, por favor aguarde...');
                //Redirecciono
                window.location.href = res.sessionUrl;
            }else{
                //Seteo el mensaje
                setMsg('La audiencia aún no está habilitada. Reintente más tarde.');
                //Oculto la espera
                setLoading(false);
                // Recargo la página pasados 5 minutos
                setTimeout(function(){
                    window.location.reload();
                  },300000)
            }
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Muestro mensaje
            ErrorMessage(data.message);
        }
    }
    //Al inicio
    useEffect(() => {
        //Busco los datos
        loadData();
    }, []);
    //Renderizo
    return (
        <div className="vertical-centered text-center w-100">
            <div className="row w-100">
                <div className="col-12">
                    <img src="/img/logo-oga.png" className="img-fluid" alt=""/>
                </div>
                <div className="col-12 m-2">
                    <h5>{ msg }</h5>
                </div>
                <div className="col-12">
                    <BounceLoader
                        css="margin: auto;"
                        size={60}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default Start;